import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { TrendingScreensService } from '../../services/trending-screens/trending-screens.service';

import { listingCardSwiperConfig } from '../../../../models';
import { SubSink } from 'subsink';

@Component({
  selector: 'signgaze-trending-screen-container',
  templateUrl: './trending-screen-container.component.html',
  styleUrls: ['./trending-screen-container.component.scss'],
})
export class TrendingScreenContainerComponent implements OnInit, OnDestroy {
  readonly subSink: SubSink = new SubSink();
  readonly listingconfig = listingCardSwiperConfig;
  isTrendingScreen: boolean;
  trendingScreens: any[] = [];
  innerWidth: any;

  constructor(
    private trendingScreensService: TrendingScreensService,
    private ref: ChangeDetectorRef
  ) {
    ref.detach();
    this.detectChnages();
  }

  ngOnInit(): void {
    this.getTrendingScreens();
    this.getScreenWidth();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  public detectChnages(): void {
    setInterval(() => {
      this.ref.detectChanges();
    }, 1000);
  }
  public getScreenWidth() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 768) {
      this.isTrendingScreen = false;
    } else {
      this.isTrendingScreen = true;
    }
  }

  public getTrendingScreens(): void {
    this.subSink.sink = this.trendingScreensService
      .getTrendingScreens()
      .subscribe({
        next: (trendingScreens): void => {
          this.trendingScreens = trendingScreens.hits;
        },
      });
  }
}
